
import { environment } from 'environments/environment';
import { Component } from '@angular/core';

import { NavigationServiceOpen } from './shared/navigation-open/navigation.service';

@Component({
  selector: 'app-open-access-root',
  templateUrl: './open-access-app.component.html',
  styleUrls: ['open-access-app.component.scss']
})
export class OpenAccessAppComponent {
  title = 'app';

  constructor(private navigationServiceOpen: NavigationServiceOpen) {

  }

  showHamburgerMenu(): boolean {
    return this.navigationServiceOpen.showHamburgerMenu;
  }

}
